export const GI_THEMES = [
  { variant: 'gi-v1', name: '深蓝', css: {
    '--gi-page':'#edf1f4', '--gi-hero':'#182f45', '--gi-hero-ink':'#fafcfb', '--gi-subtitle':'#c4d0da',
    '--gi-accent':'#244964', '--gi-active':'#244964', '--gi-active-ink':'#ffffff', '--gi-border':'#e1e7eb', '--gi-soft':'#f0f4f7',
  } },
  { variant: 'gi-green', name: '绿色', css: {
    '--gi-page':'#edf2ee', '--gi-hero':'#254c42', '--gi-hero-ink':'#fcfdf8', '--gi-subtitle':'#cadbd2',
    '--gi-accent':'#2e6552', '--gi-active':'#2e6552', '--gi-active-ink':'#ffffff', '--gi-border':'#dfe8e1', '--gi-soft':'#f0f5f0',
  } },
  { variant: 'gi-yellow', name: '黄色', css: {
    '--gi-page':'#f4f1e9', '--gi-hero':'#edd385', '--gi-hero-ink':'#453820', '--gi-subtitle':'#625337',
    '--gi-accent':'#805c1b', '--gi-active':'#e2be61', '--gi-active-ink':'#453820', '--gi-border':'#e9e3d6', '--gi-soft':'#f8f4e9',
  } },
];
export const isGIVariant = variant => GI_THEMES.some(theme => theme.variant === variant);
export const getGITheme = variant => GI_THEMES.find(theme => theme.variant === variant) || GI_THEMES[0];
